import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import { Message, MessageBox } from 'element-ui';
import { getByArea } from '@/assets/js/api.js';
// import cart from './modules/cart';
// import products from './modules/products';
// import createLogger from '../../../src/plugins/logger';

Vue.use(Vuex);

// const debug = process.env.NODE_ENV !== 'production'//判断是否为生产开发环境

export default new Vuex.Store({
	//   modules: {
	//     cart,
	//     products
	//   },
	state: {
		cdnConf:[],
		hidshow: true, //控制底部导航和按钮的显示或者隐藏footer,防止在手机端虚拟键盘顶起尾部
		isWx: false,//是否是微信端
		isIos: false,//是否是ios端
		isAndroid: false,//是否是Android端
		changePwdDialog:false,
		is630Message:0,//6.30之前的弹框
		isWJpersonMessage:0,
		defaultLearnYear:2023,
		yearList:[],
	},
	mutations: {
		getDefaultLearnYear(state, payload) {
			state.defaultLearnYear = payload;
		},
		getYearList(state, payload) {
			state.yearList = payload;
		},
	},
	actions: {
		GETYEARS({ commit }, payload) {
			return new Promise((resolve, reject) => {
				let user = JSON.parse(localStorage.getItem("user"));
				getByArea({
					province: user.unitProvince,
					city: user.unitCity,
					area: user.unitArea,
				}).then(res => {
				if (res.message.errcode == 200) {
					payload = res.data.defaultYear;
					var payload2 = res.data.years;
					commit('getDefaultLearnYear', payload);
					commit('getYearList', payload2);
					resolve();
				}
				})
				.catch(reject);
			});
	
		},
	}
	// strict: debug,
	// plugins: debug ? [createLogger()] : []
})



// WEBPACK FOOTER //
// ./src/store/index.js